jQuery(document).ready(function () {
	jQuery(document.body)
		.on('click', '.sidecart-close', function (event) {
			if(jQuery(".showOnPreview").hasClass("show")){
				event.stopImmediatePropagation();
				jQuery(".showOnPreview").removeClass("show");
				jQuery(".hiddeable").show();
				jQuery(".sidecart-header").removeClass("justify-center");
			}
		})
		.on('click', '.sidecart-close, .sidecart-overlay', (e) => {
			jQuery('#sidecart').removeClass('show');
			jQuery('.sidecart-overlay').removeClass('show');
			jQuery(".showOnPreview").removeClass("show");
			jQuery(".hiddeable").show();
			jQuery(".sidecart-header").removeClass("justify-center");
			jQuery(".sidecart-advice").hide();
		})
		.on('click', '.show-cart', () => {
			jQuery(".showOnPreview").removeClass("show");
			jQuery(".hiddeable").show();
			jQuery(".sidecart-header").removeClass("justify-center");
			jQuery('#sidecart').addClass('show');
			jQuery('.sidecart-overlay').addClass('show');
			jQuery('body, html').addClass('no-scroll');
		})
		.on('click', '.sidecart-close, .sidecart-overlay', () => {
			jQuery('body, html').removeClass('no-scroll');
		})
		.on('added_to_cart', () => {
			jQuery('body, html').addClass('no-scroll');
			jQuery('.sidecart-overlay').addClass('show');
			jQuery('#sidecart').addClass('show');
		})
		.on('wc_fragments_loaded', () => {
			loadComplementSwiper();
			typeof jdgm.customizeBadges !== 'undefined' && jdgm.customizeBadges();
		})
		.on('click', '.toggle-variation', function(){
			jQuery(this).siblings('.variation').toggle();
		})
		.on('click', '.plus-btn', function(){
			let key = jQuery(this).data('cart-item-key');
			let qtyVal = jQuery(this).siblings('.quantity-box').find(".quantity-input").data("value");
			let quantity = parseInt(qtyVal) + 1;
			updateCartQuantity(key, quantity);
		})
		.on('click', '.minus-btn', function(){
			let key = jQuery(this).data('cart-item-key');
			let qtyVal = jQuery(this).siblings('.quantity-box').find(".quantity-input").data("value");
			let quantity = parseInt(qtyVal) - 1;
			updateCartQuantity(key, quantity);
		})
		.on('change', '#factory-priority', function(){
			let checkboxValue = jQuery(this).prop("checked");
			let isPriorityCartKey = jQuery(this).data("cart-item-key");
			let elementScroll = jQuery(".sidecart-body").scrollTop();
			let $thisbutton = this;
			if(checkboxValue){
				jQuery.ajax({
					type: "POST",
					url: woocommerce_params.wc_ajax_url
						.toString()
						.replace("%%endpoint%%", "add_to_cart"),
					data: {
						product_id: jQuery($thisbutton).data("product_id"),
						quantity: checkboxValue ? 1 : -1,
					},
					beforeSend: function () {
						jQuery($thisbutton).prop("disabled", true);
						jQuery(".sidecart-bottom, .sidecart-body").css("opacity", 0.4).css("pointer-events", "none");
					},
					complete: function () {
						jQuery($thisbutton).prop("disabled", false);
						jQuery(".sidecart-bottom, .sidecart-body").css("opacity", 1).css("pointer-events", "unset");
						jQuery(".sidecart-body").scrollTop(elementScroll);
					},
					success: function (response) {
						if (!response.error) {
							jQuery(document.body).trigger("added_to_cart", [
								response.fragments,
								response.cart_hash
							]);
							jQuery($thisbutton).prop("checked", checkboxValue);
						}else{
							jQuery($thisbutton).prop("checked", !checkboxValue);
						}
					},
					error: function () {
						jQuery($thisbutton).prop("checked", !checkboxValue);
					},
				});
			}else{
				updateCartQuantity(isPriorityCartKey,0);
			}
		})
		.on('click', '.see-design', function(){
			let productTitle = jQuery(this).data("title");
			let productVariations = jQuery(this).find(".product-variations .variation");
			let productPreview = jQuery(this).data("preview") || jQuery(this).closest(".woocommerce-mini-cart-item").find(".sidecart-image-link img").attr("src") || false;

			if(productTitle && productTitle.length > 1 && productVariations.length && productPreview){
				jQuery(".sidecart-preview .product-title").html(productTitle);
				jQuery(".sidecart-preview .product-variations").html(productVariations.clone());
				jQuery(".sidecart-preview .preview-customily").html(`<img class="customily-thumb" src="${productPreview}">`);
				checkImgs(true);
				jQuery(".showOnPreview").addClass("show");
				jQuery(".hiddeable").hide();
				jQuery(".sidecart-header").addClass("justify-center");
			}
		})
		.on('click', '.sidecart-preview button', function(){
			jQuery(".showOnPreview").removeClass("show");
			jQuery(".hiddeable").show();
			jQuery(".sidecart-header").removeClass("justify-center");
		})
		.on('click', '.toggle-suggestion', function(){
			const $suggestedProducts = jQuery(".sidecart-suggestedProducts").first(); 
			jQuery("body").prepend($suggestedProducts);
			$suggestedProducts.show();
		})
});

function updateCartQuantity(key, quantity) {
	let elementScroll = jQuery(".sidecart-body").scrollTop();
	jQuery(".sidecart-bottom, .sidecart-body").css("opacity", 0.4).css("pointer-events", "none");
	jQuery.ajax({
		url: woocommerce_params.ajax_url,
		type: 'POST',
		data: {
			action: 'woocommerce_update_cart_item_quantity',
			cart_item_key: key,
			quantity: quantity,
		},
		success: function (response) {
			if (response.fragments) {
				jQuery(document.body).trigger("added_to_cart", [
					response.fragments,
					response.cart_hash
				]);

				typeof jdgm.customizeBadges !== 'undefined' && jdgm.customizeBadges();
			}
		},
		error: function () {
			location.reload();
		},
		complete: function(){
			jQuery(".woocommerce-mini-cart__buttons").css("pointer-events", "unset");
			jQuery(".quantity-buttons").css("opacity", 1).css("pointer-events", "unset");
			jQuery(".sidecart-body").scrollTop(elementScroll);
		}
	});
}
